export class SpeechRecognitionTask {
    isRecording = false;
    isProcessing = false;
    recorder = null;
    stream = null;
    chunks = [];
    cancelled = false;
    endpoint;
    ready;
    onComplete;
    constructor(endpoint, onComplete) {
        this.endpoint = endpoint;
        this.onComplete = onComplete;
        this.ready = this.begin();
    }
    async begin() {
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.recorder = new MediaRecorder(this.stream, { mimeType: "audio/webm;codecs=opus" });
        this.chunks = [];
        this.recorder.ondataavailable = (e) => {
            if (e.data.size > 0)
                this.chunks.push(e.data);
        };
        this.recorder.start();
        this.isRecording = true;
    }
    async finish() {
        await this.ready;
        if (!this.recorder || this.cancelled) {
            this.onComplete();
            return { text: "", isFinal: true };
        }
        const blob = await new Promise((resolve) => {
            this.recorder.onstop = () => {
                resolve(new Blob(this.chunks, { type: "audio/webm" }));
            };
            this.recorder.stop();
        });
        this.teardown();
        this.isRecording = false;
        this.isProcessing = true;
        try {
            const fd = new FormData();
            fd.append("audio", blob, "recording.webm");
            const r = await fetch(this.endpoint, {
                method: "POST",
                body: fd,
                signal: AbortSignal.timeout(30000),
            });
            if (!r.ok)
                throw new Error("HTTP " + r.status);
            const data = await r.json();
            this.isProcessing = false;
            this.onComplete();
            return { text: (data.text || "").trim(), isFinal: true };
        }
        catch (err) {
            this.isProcessing = false;
            this.onComplete();
            throw err;
        }
    }
    cancel() {
        this.cancelled = true;
        if (this.recorder?.state === "recording")
            this.recorder.stop();
        this.teardown();
        this.isRecording = false;
        this.isProcessing = false;
        this.onComplete();
    }
    teardown() {
        this.stream?.getTracks().forEach((t) => t.stop());
        this.recorder = null;
        this.stream = null;
        this.chunks = [];
    }
}
